import { Pipe, PipeTransform, inject } from "@angular/core";
import { LgFormatTypePipe } from "@logex/framework/ui-core";

@Pipe({
    name: "fmtSafeType", pure: true,
    standalone: false
})
export class SafeFormatPipe implements PipeTransform {
    private _format = inject(LgFormatTypePipe);

    transform(
        obj: string | number | undefined | null,
        type: string,
        options?: { decimals?: number; forceSign?: boolean; zeroDash?: boolean }
    ): string {
        if (obj == null) return "—";

        if (type === "string") {
            return obj.toString().trim();
        }
        return this._format.transform(
            obj,
            type,
            options?.decimals,
            options?.forceSign,
            options?.zeroDash
        );
    }
}
